import React from "react";
import "../styles/WhoWeAre.css";

function WhoWeAre({ language }) {
  return (
    <section id="whoweare" className="whoweare-section">
      <h2 className="section-title">
        
        <span lang="en">Meet our founder
          </span>
            <span lang="fr">Rencontrez notre fondateur
              </span>
            
      </h2>
      <div className="founder-cards-grid">
        {/* Founder card */}
        <div className="founder-card founder-horizontal">
          <div className="founder-row">
            <div className="founder-image">
              <img
                src="https://raw.githubusercontent.com/Helmifalfie7/nexofortis/main/assets/hamdi-pro.jpeg"
                alt="Hamdi Arem"
              />
            </div>
            <div className="founder-info">
              <h3 className="founder-name">Hamdi Arem</h3>
              <p className="founder-role"> {language === "fr" ? "Fondateur & PDG" : "Founder & CEO"}</p>
              <a
                href="https://www.linkedin.com/in/hamdi-a-a9877571/"
                className="linkedin-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin"></i> LinkedIn
              </a>
            </div>
          </div>
          <p className="founder-description">
            <span lang="en">
            He is an Integration Architect and Team Leader with over 8 years of experience in creating
            cutting-edge integration solutions on MuleSoft, Workato, Salesforce, and custom platforms.
            He leads enterprise integration programs, aligns technical delivery with business objectives,
            and designs architectures based on APIs driven by events that enable agile and future-ready digital ecosystems.
            </span>
            <span lang="fr">
              Il est architecte d'intégration et chef d'équipe et possède plus de 8 ans d'expérience dans la création de
              solutions d'intégration de pointe sur MuleSoft, Workato, Salesforce et des plateformes personnalisées.
              Il dirige des programmes d'intégration d'entreprise, aligne la prestation technique sur les objectifs commerciaux et
              conçoit des architectures basées sur des API pilotées par des événements qui permettent la mise en place d'écosystèmes numériques agiles et prêts pour l'avenir.
            </span>
                     
          </p>
        </div>
        
        {/* Senior Developer card 
        
        <div className="founder-card founder-horizontal">
           
          <div className="founder-row">
           
            <div className="founder-image">
              <img
                src="https://raw.github.com/Helmifalfie7/nexofortis/main/assets/helmi-pro.jpg"
                alt="Helmi el arem"
              />
            </div>
             
            <div className="founder-info">
              
              <h3 className="founder-name">Helmi Arem</h3>
           
              <p className="founder-role"> {language === "fr" ? "Co‑fondateur" : "Co‑founder"}</p>
              
              <a
                href="https://linkedin.com/in/helmi-el-arem-9a775283"
                className="linkedin-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin"></i> LinkedIn
              </a>
            </div>
          </div>
         
          <p className="founder-description">
             
            <span lang="en">
            He is an Integration Developer with over 3 years of experience specializing in API design, management, and monitoring using MuleSoft Anypoint Platform. <br />
            He has a proven track record of delivering reliable and secure integration solutions and resolving production issues effectively. 
            He is passionate about continuous learning, 
            applying best practices, and leveraging emerging technologies to drive innovation and improve business outcomes.
            </span>
         
            <span lang="fr">
              Il est développeur d'intégration et possède plus de 3 ans d'expérience dans la conception, la gestion et la surveillance d'API à l'aide de la plateforme MuleSoft Anypoint. 
              Il a fait ses preuves dans la fourniture de solutions d'intégration fiables et sécurisées et dans la résolution efficace des problèmes de production. 
              Il est passionné par l'apprentissage continu, 
              l'application des meilleures pratiques et l'exploitation des technologies émergentes pour stimuler l'innovation et améliorer les résultats commerciaux.
            </span>
          
          </p>
        </div>
        */}

     
      </div>
    </section>
  );
}

export default WhoWeAre;
